<template>
	<div class="container">
		<p>筛选查询</p>
		<div class="container crumbs">
			<div class="handle-search ">
				<e-search :data="formData" :field-list="fieldList" :list-type-info="listTypeInfo" :btnStyle="btnStyle"
					@handleReset="handleClear" @handleFilter="handleQuery"></e-search>
			</div>
		</div>
		<p>日志列表</p>
		<div class="container crumbs">
			<TableList :loading="loading" :table-data="tableData" :table-label="tableLabel" @handleButton="handleButton"
				@handleSortChange="handleSortChange" @handleSelectionChange="handleSelectionChange"></TableList>
			<div class="pagination">
				<el-pagination layout="total, sizes, prev, pager, next, jumper" :current-page="page.pageNum"
					:page-sizes="[10, 20,50, 100, 200]" :page-size="page.pageSize" :total="pageTotal" prev-text="上一页" next-text="下一页"
					@current-change="handlePageChange" @size-change="handleSizeChange"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import ESearch from "../../components/common/e-search";
	import TableList from "../../components/common/e-table-list";
	import api from "../../api/logsystem/index";
	export default {
		//   name: "productCatalogExam",
		components: {
			ESearch,
			TableList
		},
		data() {
			return {
				loading: false,
				tableData: [],
				tableLabel: [{
						label: '单品编号',
						param: "code",
						align: 'center'
					},
					{
						label: '单品名称',
						param: "name",
						align: 'center'
					},
					{
						label: "供应商",
						param: "supplierCompanyName",
						align: "center"
					},
					{
						label: "IP地址",
						param: "memberIp",
						align: "center"
					},
					{
						label: "协议名称",
						param: "",
						align: "center",
						width: "200",
						render: (row) => {
							if (row.logType === "1") {
								return "新增人员"
							} else if (row.logType == "2") {
								return "修改人员"
							} else if (row.logType == "3") {
								return "删除人员"
							}
						}
					},
					{
						label: "操作人",
						param: "createName",
						align: "center"
					},
					{
						label: "操作时间",
						param: "mobile",
						align: "center"
					},
				],
				//   tableOption: {
				//     label: "操作",
				//     width: "300",
				//     fixed: "right",
				//     options: [
				//       { label: "查看详情", type: "primary", methods: "handleOrderDetail" },
				//       { label: "查看并确认", type: "primary", methods: "handleOrderConfirm" },
				//      ],
				//     flag: true,
				//   },
				fieldList: [{
						label: '单品名称',
						type: 'input',
						value: 'applicationStatus'
					},
					{
						label: '单品编号',
						type: 'input',
						value: 'cellPhoneNumber'
					},
					{
						label: '操作类型',
						type: 'select',
						value: 'supplierCompanyName',
						list: 'applicationStatus'
					},
					{
						label: '操作时间',
						type: 'date',
						value: 'startTime',
						dateType: 'daterange'
					},
					{
						label: '供应商',
						type: 'input',
						value: 'loginID'
					},
					{
						label: '操作人',
						type: 'input',
						value: 'emailAddress'
					},
					{
						label: 'IP地址',
						type: 'input',
						value: 'memberIp'
					}
				],
				listTypeInfo: {
					applicationStatus: [{
							id: "1",
							name: '单品新增'
						},
						{
							id: '2',
							name: '单品编辑'
						},
						{
							id: '3',
							name: '单品上架'
						},
						{
							id: '4',
							name: '单品下架'
						},
						{
							id: '5',
							name: '单品修改'
						},
					],
				},
				btnStyle: [{
						icon: "el-icon-refresh",
						text: "重置"
					},
					{
						icon: "el-icon-search",
						text: "查询",
						type: "primary"
					},
				],
				pageTotal: 0,
				formData: {
					supplierCompanyName: '',
					startTime: '',
					endTime: '',
					applicationStatus: '',
					loginID: "",
					cellPhoneNumber: "",
					emailAddress: "",
					memberIp: ""
				},
				page: {
					pageNum: 1,
					pageSize: 10,
					logType: 3
				}
			}
		},
		created() {
			this.AccessAoThePaging()
		},
		methods: {
			// handleSearch() {
			//    this.formData.pageNum = 10
			//  },
			//重置
			handleClear() {
				this.AccessAoThePaging()
			},
			//查询
			handleQuery(val) {
				console.log(val)
				let Query = {
					name: val.applicationStatus,
					code: val.cellPhoneNumber,
					startTime: val.startTime[0],
					supplierCompanyName: val.loginID,
					endTime: val.startTime[1],
					createName: val.emailAddress,
					pageNum: this.page.pageNum,
					pageSize: this.pageSize,
					memberIp:val.memberIp,
					logType: 3
				}
				api.queryMemberPage(Query).then((res) => {
					this.tableData = res.data.records
					this.pageTotal = res.data.total
				})
			},
			// //
			// statusFormatter(row){
			//     let name =''
			//     this.listTypeInfo.applicationStatus.forEach(item=>{
			//         if(item.id==row.logType){
			//             console.log(item.id)
			//             name=item.name
			//         }
			//     })
			//     return name
			// },
			handleButton(val) {
				console.log(val)
			},
			handleSortChange() {},
			handleSelectionChange() {},
			//分页导航
			handlePageChange(val) {
				this.page.pageNum = val
				this.AccessAoThePaging()
			},
			handleSizeChange(pageSize) {
				console.log(pageSize)
				this.page.pageSize = pageSize
				this.AccessAoThePaging()
			},
			async AccessAoThePaging() {
				let res = await api.queryProductLogByPage(this.page)
				console.log(res)
				this.tableData = res.data.records
				this.pageTotal = res.data.total
			}
		}
	}
</script>

<style scoped lang="scss">
	.time {
		::v-deep .el-input {
			width: 80px;
		}
	}
</style>
